import {ReactElement, ReactNode, useEffect, useState} from "react";
import {styled} from "styled-components";

import {getFournisseurs as fetchFournisseurs} from "@/Api/fournisseur";
import IconSearch from "@/assets/iconSearch.svg?react";
import {Button} from "@/components/Button/Button";
import {Input} from "@/components/Formulaire/Input/Input";
import {LoadingOrError} from "@/components/LoadingOrError/LoadingOrError";
import {Pagination} from "@/components/Paggination/Paggination";
import {AppContext} from "@/context/AppContext";
import {HookFormContext, HookFormContextType} from "@/context/HookFormContext";
import {
  UserParamContext,
  UserParamContextType,
} from "@/context/UserParamContext";
import {breakpoints} from "@/GlobalStyle";
import {useGetContext} from "@/hooks/useGetContext/useGetContext";
import {useLoadingState} from "@/hooks/useLoadingState/useLoadingState";
import {AppContext as AppContextType} from "@/ts/appContext";
import {FournisseurSearch as TypeFournisseurSearch} from "@/ts/fournisseur";
import {Pagination as PaginationType} from "@/ts/pagination";

const SearchFormStyled = styled.form`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 40px 0 50px 0;
  gap: 20px;
`;
const ContentInputStyled = styled.div`
  flex: 1;
  max-width: 600px;
  min-width: 400px;
  display: flex;
  justify-content: center;
  gap: 20px;
  & input {
    width: 100%;
  }
  @media (max-width: ${breakpoints.sm}) {
    min-width: 250px;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    & button {
      height: 40px;
      align-self: center;
    }
  }
`;

// TODO: décommenter quand on mettra les filtres

// const ContentFiltreStyled = styled.div`
//   flex: 1;
//   max-width: 500px;
//   min-width: 500px;
//   display: flex;
//   justify-content: center;
//   gap: 20px;
//   @media (max-width: ${breakpoints.sm}) {
//     min-width: 250px;
//     width: 100%;
//     flex-direction: column;
//     align-items: flex-start;
//   }
// `;
const StyledPagination = styled(Pagination)`
  margin: 30px auto;
`;

export function FournisseurSearch({
  updateFournisseurList,
  updatePagination,
  pagination,
  children,
}: {
  updateFournisseurList: React.Dispatch<
    React.SetStateAction<TypeFournisseurSearch[]>
  >;
  updatePagination: React.Dispatch<React.SetStateAction<PaginationType | null>>;
  pagination: PaginationType | null;
  children: ReactNode;
}): ReactElement {
  const {API} = useGetContext<AppContextType>(AppContext, "AppContext");
  const {currentCampagne, currentContremarque} =
    useGetContext<UserParamContextType>(UserParamContext, "UserParamContext");

  const loadingState = useLoadingState();

  const {register, handleSubmit, getValues} =
    useGetContext<HookFormContextType>(HookFormContext, "HookFormContext");
  const [savedCampagneAndContremarque, setSavedCampagneAndContremarque] =
    useState<{campagne: string; contremarque: string}>({
      campagne: "",
      contremarque: "",
    });
  const getFournisseurs = async (): Promise<void> => {
    if (currentCampagne.value) {
      const {fournisseurs, pagination} = await loadingState.executeWithLoading(
        () =>
          fetchFournisseurs(API, {
            itemsPerPage: "20",
            campagne_id: currentCampagne.value.toString(),
            q: getValues("searchQuery") || "",
          })
      );
      updateFournisseurList(fournisseurs);
      updatePagination(pagination);
    }
  };
  useEffect(() => {
    if (
      savedCampagneAndContremarque.campagne !== currentCampagne.value ||
      savedCampagneAndContremarque.contremarque !== currentContremarque.value
    ) {
      getFournisseurs();
      setSavedCampagneAndContremarque({
        campagne: currentCampagne.value,
        contremarque: currentContremarque.value,
      });
    }
  }, [currentCampagne, currentContremarque]);

  const onSubmit = async (): Promise<void> => {
    getFournisseurs();
  };
  return (
    <div>
      <SearchFormStyled
        data-testid="SearchFormStyled"
        onSubmit={handleSubmit(onSubmit)}>
        {/* // TODO: Ajouter les filtres */}
        {/* <ContentFiltreStyled data-testid="ContentFiltreStyled">
          {userType === "Adherent" ? (
            <>
              <InputLabel
                type="radio"
                isInColumn={false}
                reverseOrder={true}
                value={"all"}
                label="Tous"
                id="filtre_all"
                {...register("filtre")}
              />
              <InputLabel
                type="radio"
                label="Contrat en cours"
                isInColumn={false}
                value="contrat"
                reverseOrder={true}
                id="filtre_contrat"
                {...register("filtre")}
              />
              <InputLabel
                type="radio"
                label="Pas de contrat"
                value="noContrat"
                id="filtre_noContrat"
                isInColumn={false}
                reverseOrder={true}
                {...register("filtre")}
              />
            </>
          ) : null}
        </ContentFiltreStyled> */}
        <ContentInputStyled data-testid="ContentInputStyled">
          <Input
            placeholder="Rechercher fournisseur"
            {...register("searchQuery")}
          />
          <Button type="submit" label="CHERCHER" icon={IconSearch} />
        </ContentInputStyled>
      </SearchFormStyled>
      <LoadingOrError
        loadingState={loadingState}
        buttonToRefresh={true}
        onRetry={async (): Promise<void> => {
          await loadingState.executeWithLoading(getFournisseurs);
        }}
        data={pagination}>
        {children as ReactElement}
      </LoadingOrError>
      {pagination !== null ? (
        <StyledPagination
          data-testid="StyledPagination"
          pagination={pagination}
          onChangePagination={() => {
            return;
          }}
        />
      ) : null}
    </div>
  );
}
